var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 0A3.6 3.6 0 0124 3.6v10.682a3.6 3.6 0 01-3.6 3.6H18a1.2 1.2 0 00-1.2 1.2v3.32a.6.6 0 01-1.023.425l-4.626-4.596a1.2 1.2 0 00-.846-.349H3.6a3.6 3.6 0 01-3.6-3.6V3.6A3.6 3.6 0 013.6 0h16.8zm-2.991 8.575c-1.108 1.609-3.15 2.631-5.416 2.631-2.24 0-4.264-.999-5.38-2.58a.75.75 0 10-1.226.866c1.404 1.988 3.889 3.214 6.606 3.214 2.748 0 5.258-1.255 6.651-3.28a.75.75 0 00-1.235-.851z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.ec03be23e5f76d04f564080a06e16fda.svg";
export { ForwardRef as ReactComponent };